module.exports = __webpack_public_path__ + "fonts/WorkSans-Bold.c3c52b1.ttf";